export const primaryBlue = "#578EDD"
export const secondaryBlue = "#CDE4FF"
export const darkBlue = "#2664ba"
export const aqua = "#17e2ec"
